import { CommonResponse } from '@xver/@types/api';
import { BaremetalInstance, BaremetalPaymentPeriod } from '@xver/@types/instance';
import {
    BaremetalCommand,
    BaremetalLanuchOptions,
    LaunchBaremetalInstanceData,
    XverBaremetalNode,
} from '@xver/@types/launch';
import httpClient from '@xver/libs/axios';

const ENDPOINTS = {
    GET_LAUNCH_OPTIONS: '/v1/baremetals/launch/options',
    GET_NODES: '/v1/baremetals/nodes',
    LAUNCH: '/v1/baremetals/launch',
    GET_LIST: '/v1/baremetals',
    GET_ONE: (id: any) => `/v1/baremetals/${id}`,
    PERMUTE_AUTO_RENEW: (id: any) => `/v1/baremetals/${id}/permute-auto-renew`,
    CHANGE_PAYMENT_PERIOD: (id: any, period: BaremetalPaymentPeriod) =>
        `/v1/baremetals/${id}/change-payment-period/${period}`,
    SEND_COMMAND: (id: any, command: BaremetalCommand) => `/v1/baremetals/${id}/${command}`,
    DELETE: (id: any) => `/v1/baremetals/${id}`,
};

export function getBaremetalLaunchOptions(): Promise<BaremetalLanuchOptions> {
    return httpClient.get(ENDPOINTS.GET_LAUNCH_OPTIONS);
}

export function getAvailableBaremetalNodes(): Promise<XverBaremetalNode> {
    return httpClient.get(ENDPOINTS.GET_NODES);
}

export function launchBaremetal(data: LaunchBaremetalInstanceData): Promise<CommonResponse> {
    return httpClient.post(ENDPOINTS.LAUNCH, data);
}

export function getBaremetals(): Promise<BaremetalInstance[]> {
    return httpClient.get(ENDPOINTS.GET_LIST);
}

export function getBaremetal(id: any): Promise<BaremetalInstance> {
    return httpClient.get(ENDPOINTS.GET_ONE(id));
}

export function permuteAutoRenew(id: any): Promise<CommonResponse> {
    return httpClient.post(ENDPOINTS.PERMUTE_AUTO_RENEW(id));
}

export function changePaymentPeriod(
    id: any,
    period: BaremetalPaymentPeriod
): Promise<CommonResponse> {
    return httpClient.post(ENDPOINTS.CHANGE_PAYMENT_PERIOD(id, period));
}

export function sendCommand(id: any, command: BaremetalCommand): Promise<CommonResponse> {
    return httpClient.post(ENDPOINTS.SEND_COMMAND(id, command));
}

export function deleteBaremetal(id: any): Promise<CommonResponse> {
    return httpClient.delete(ENDPOINTS.DELETE(id));
}
